import { Button, Colors, Display, Widths } from "Views/Components/Button/Button";
import CustomerApplicationStatusBox from "Views/Components/CustomerApplications/CustomerApplicationStatusBox";
import { CustomerApplicationSummary, CustomerApplicationSummaryUtil } from "Hooks/Api/apiCustomerApplications";
import { OverviewWidget } from "Views/Components/Widgets/OverviewWidget";


export function CustomerApplicationReferenceWidget(props: { model: CustomerApplicationSummary }) {
	const { model } = props;
	const status = model.status ?? "UNKNOWN"
	const titleNode = 
		<div className="credit-info-header-grid-wrapper">
			<h6>Application Ref: {model.legacyId}</h6>
			<CustomerApplicationStatusBox status={status} displayType="pill" />
		</div>

	return (
		<OverviewWidget
			title={titleNode}
			className="credit-info"
		>
			<span className="credit-info-subtitle">Created: {new Date(model.created).toLocaleDateString()}</span>
			<div className="credit-info-grid-wrapper">
				<div>
					<h5>{CustomerApplicationSummaryUtil.getCreditRequested(model)}</h5>
					<span className="credit-info-subtitle">Credit requested</span>
				</div>
				<div>
					<h5>{CustomerApplicationSummaryUtil.getCreditApproved(model)}</h5>
					<span className="credit-info-subtitle">Credit approved</span>
				</div>
			</div>
			<Button
				colors={Colors.Primary}
				display={Display.Solid}
				icon={{icon: "arrow-right-up", iconPos: "icon-right" }}
				widths={Widths.fullWidth}
				disabled
			>
				Process decision
			</Button>
		</OverviewWidget>
	)
}